<script>
    import {createEventDispatcher, onMount} from "svelte";
    import {scrollToElementId} from "../core/utils.js";
    const dispatch = createEventDispatcher();

    export let opened = false;
    export let sections = [];

    let scrollableListEl = null;
    let scrollable = false;

    onMount(() => {
        scrollableListEl = document.querySelector('#sections ul');
        if (scrollableListEl) {
            scrollable = scrollableListEl.scrollWidth > scrollableListEl.getBoundingClientRect().width;
        }
    });

    function scrollToSection (id) {
        scrollToElementId(id);
    }

    function scrollPrev() {
        if (scrollableListEl) {
            scrollableListEl.scrollLeft -= 100;
        }
    }

    function scrollNext() {
        if (scrollableListEl) {
            scrollableListEl.scrollLeft += 100;
        }
    }

</script>

<style>
    .sections-container {
        overflow: hidden;
        padding: 0 1.25rem;
        display: flex;
        justify-content: space-between;
    }
    ul {
        display: flex;
        align-items: center;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-behavior: smooth;
        border-bottom: 1px solid #dbc9ae4a;
    }
    ul::-webkit-scrollbar {
        display: none;
    }

    li {
        white-space: nowrap;
        padding: 0.75rem 0.5rem 1.5rem 0.5rem;
        cursor: pointer;
        border-bottom: 1px solid transparent;
    }
    @media (max-width: 768px) {
        .sections-container {
            padding: 0;
        }
        ul {
            padding: 0 1.25rem;
        }
    }
    @media (min-width: 768px) {
        li:hover {
            color: var(--accent);
            border-bottom: 1px solid var(--accent);
        }
    }
    .scroll-btn {
        padding: 0 1rem;
        background: transparent;
        color: var(--accent);
        margin-bottom: .5rem;
        border: none;
        cursor: pointer;
    }
</style>

<div id="sections" class="sections-container">

    {#if (scrollable)}
        <button class="scroll-btn" on:click={() => scrollPrev()}>
            <svg width="8" height="16" viewBox="0 0 6 10" style="transform: rotateY(180deg)" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 9.99999C0.434424 10.0008 0.369407 9.98786 0.309129 9.96202C0.248851 9.93619 0.194646 9.89803 0.15 9.84999C-0.05 9.64999 -0.05 9.33999 0.15 9.13999L4.3 4.98999L0.15 0.84999C-0.05 0.64999 -0.05 0.33999 0.15 0.13999C0.35 -0.0600098 0.66 -0.0600098 0.86 0.13999L5.35 4.64999C5.55 4.84999 5.55 5.15999 5.35 5.35999L0.85 9.84999C0.75 9.94999 0.62 9.99999 0.5 9.99999Z" fill="currentColor"/>
            </svg>
        </button>
    {/if}

    <ul class="scrollbar flex-fill" class:jc-center={!scrollable}>
        {#each sections as section}
            {#if (section?.title !== undefined && section?.title !== '' && section.sectionType !== 'text-block')}
                <li class="user-select-none"
                    id={"section-selector-" + section.id}
                    data-type={section.sectionType}
                    on:click={() => scrollToSection('s' + section.id)}>
                    { section.title }
                </li>
            {/if}
        {/each}
    </ul>

    {#if (scrollable)}
        <button class="scroll-btn" on:click={() => scrollNext()}>
            <svg width="8" height="16" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 9.99999C0.434424 10.0008 0.369407 9.98786 0.309129 9.96202C0.248851 9.93619 0.194646 9.89803 0.15 9.84999C-0.05 9.64999 -0.05 9.33999 0.15 9.13999L4.3 4.98999L0.15 0.84999C-0.05 0.64999 -0.05 0.33999 0.15 0.13999C0.35 -0.0600098 0.66 -0.0600098 0.86 0.13999L5.35 4.64999C5.55 4.84999 5.55 5.15999 5.35 5.35999L0.85 9.84999C0.75 9.94999 0.62 9.99999 0.5 9.99999Z" fill="currentColor"/>
            </svg>
        </button>
    {/if}
</div>
